export default {
  state: {
    event: {},
  },

  mutations: {
    setCurrentEvent(state, event) {
      state.event = event;
    },
  },
};
